var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FullScreenHelper } from '../../full-screen-helper';
var FullScreenComponent = /** @class */ (function () {
    function FullScreenComponent(elementRef) {
        var _this = this;
        this.elementRef = elementRef;
        this.isFullScreenChange = new EventEmitter();
        this.stateChanged = new EventEmitter();
        this.onKeyEscListener = function () { return _this.exitHandler(); };
    }
    FullScreenComponent.prototype.toNormalWindow = function () {
        this.exitFullscreen();
    };
    FullScreenComponent.prototype.exitHandler = function () {
        var doc = document;
        if (!doc.fullscreenElement && !doc.webkitIsFullScreen && !doc.mozFullScreen && !doc.msFullscreenElement) {
            this.isFullScreen = false;
            this.restoreCss();
            this.isFullScreenChange.emit(false);
            this.stateChanged.emit(false);
            this.exitFullscreen();
        }
    };
    FullScreenComponent.prototype.ngOnDestroy = function () {
        document.removeEventListener('fullscreenchange', this.onKeyEscListener);
        document.removeEventListener('webkitfullscreenchange', this.onKeyEscListener);
        document.removeEventListener('mozfullscreenchange', this.onKeyEscListener);
        document.removeEventListener('MSFullscreenChange', this.onKeyEscListener);
    };
    FullScreenComponent.prototype.ngOnInit = function () {
        if (this.isFullScreen) {
            this.requestFullScreen();
        }
        // chrome 全屏状态下按esc 不触发 keydown 事件
        document.addEventListener('fullscreenchange', this.onKeyEscListener);
        document.addEventListener('webkitfullscreenchange', this.onKeyEscListener);
        document.addEventListener('mozfullscreenchange', this.onKeyEscListener);
        document.addEventListener('MSFullscreenChange', this.onKeyEscListener);
    };
    FullScreenComponent.prototype.ngOnChanges = function (changes) {
        var isFullScreenChange = changes['isFullScreen'];
        if (isFullScreenChange.isFirstChange()) {
            return;
        }
        if (isFullScreenChange.previousValue === isFullScreenChange.currentValue) {
            return;
        }
        var newValue = isFullScreenChange.currentValue;
        if (newValue) {
            this.requestFullScreen();
        }
    };
    FullScreenComponent.prototype.requestFullScreen = function () {
        var _this = this;
        var de = document.documentElement;
        if (de.requestFullscreen) {
            de.requestFullscreen();
        }
        else if (de.mozRequestFullScreen) {
            de.mozRequestFullScreen();
        }
        else if (de.webkitRequestFullScreen) {
            de.webkitRequestFullScreen();
        }
        this.isFullScreen = true;
        this.isFullScreenChange.emit(true);
        this.adjustCss();
        setTimeout(function () { return _this.stateChanged.emit(true); }, 500);
    };
    FullScreenComponent.prototype.adjustCss = function () {
        // 特殊处理模态框中全屏
        var modal = $(this.elementRef.nativeElement).parents('.modal.show .modal-dialog');
        if (modal.length > 0) {
            $(modal[0]).css({
                transform: 'none'
            });
        }
        $('html').attr('data-overflow', $('html').css('overflow'));
        $('html').css('overflow', 'hidden');
    };
    FullScreenComponent.prototype.restoreCss = function () {
        var modal = $(this.elementRef.nativeElement).parents('.modal.show .modal-dialog');
        if (modal.length > 0) {
            $(modal[0]).css({
                '-webkit-transform': 'translate(0, 0)',
                'transform': 'translate(0, 0)'
            });
        }
        $('html').css('overflow', $('html').attr('data-overflow'));
    };
    FullScreenComponent.prototype.exitFullscreen = function () {
        var _this = this;
        FullScreenHelper.exitFullScreen();
        this.isFullScreen = false;
        this.isFullScreenChange.emit(false);
        this.restoreCss();
        setTimeout(function () { return _this.stateChanged.emit(false); }, 500);
    };
    __decorate([
        Input()
    ], FullScreenComponent.prototype, "isFullScreen", void 0);
    __decorate([
        Output()
    ], FullScreenComponent.prototype, "isFullScreenChange", void 0);
    __decorate([
        Output()
    ], FullScreenComponent.prototype, "stateChanged", void 0);
    FullScreenComponent = __decorate([
        Component({
            selector: 'fc-full-screen',
            template: "<div class=\"full-screen-container\" [class.active]=\"isFullScreen\"> <div *ngIf=\"isFullScreen\" class=\"header-bar\"> <ng-content select=\"[header-bar]\"></ng-content> <span class=\"right block arrow-container\"> <ng-content select=\"[header-toolbar]\"></ng-content> <a class=\"toggle-arrow\" (click)=\"toNormalWindow()\"> <i class=\"fcloud-unfullscreen-chart\"></i> </a> </span> </div> <ng-content class=\"full\" select=\"[full-screen-content]\"></ng-content> </div> ",
            styles: [".full-screen-container { position: relative; width: 100%; height: 100%; overflow: auto; .full-screen-content{ height: 100%; padding-top: 0px; } } .header-bar { position: relative; height: 1px; background-color: #ffffff; position: fixed; top:0; left: 0; border: none; width: 100%; z-index: 99999; * { visibility: hidden; } } .toggle-arrow { cursor: pointer; i{ font-size: 16px; color: #C4C6CF; } } .right { float: right; } .block { display: inline-block; } .full-screen-container.active { position: fixed; background-color: white; top: 0; left: 0; width: 100%; z-index:1999; .header-bar:hover { background-color: white; min-height: 50px; padding-left: 20px; border: 1px solid #ebedf2; display: flex; justify-content: space-between; align-items: center; * { visibility: visible; } } .full { width: 100%; height: 100%; } } .arrow-container{ margin-right: 20px; } .full-screen-container .header-bar .arrow-container .la.la-expand:before { content: \"\\f1a4\"; } .fcloud-unfullscreen-chart:before{ color: #a0a2ad; } "],
            encapsulation: ViewEncapsulation.None,
        })
    ], FullScreenComponent);
    return FullScreenComponent;
}());
export { FullScreenComponent };
